import { render, staticRenderFns } from "./ForgetPsw.vue?vue&type=template&id=4fc229d9&scoped=true&"
import script from "./ForgetPsw.vue?vue&type=script&lang=js&"
export * from "./ForgetPsw.vue?vue&type=script&lang=js&"
import style0 from "./ForgetPsw.vue?vue&type=style&index=0&id=4fc229d9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc229d9",
  null
  
)

export default component.exports